import React, { Component } from "react";
import { Menu, Segment, Sidebar } from "semantic-ui-react";
import ReactDOM from "react-dom";
import { Card, CardBody, Button } from "reactstrap";
import {
  Map,
  Marker,
  InfoWindow,
  GoogleApiWrapper,
  Polyline,
} from "google-maps-react";
import { Progress } from "reactstrap";
import createHistory from "history/createBrowserHistory";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
// import policeIcon from '../../../../resources/icons/policeman2.png';
import { Link } from "react-router-dom";
import "./styles/style.scss";

if (!window.AppHistory) {
  window.AppHistory = createHistory();
}

class InfoWindowEx extends Component {
  constructor(props) {
    super(props);
    this.infoWindowRef = React.createRef();
    this.contentElement = document.createElement("div");
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.children !== prevProps.children) {
      ReactDOM.render(
        React.Children.only(this.props.children),
        this.contentElement
      );
      this.infoWindowRef.current.infowindow.setContent(this.contentElement);
    }
  };

  render() {
    return <InfoWindow ref={this.infoWindowRef} {...this.props} />;
  }
}

export class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Size: props.heidIcon ? props.heidIcon : 45,
      activeMarker: {},
      dataRecieve: props.dataDrawer,
      tags: "",
      dataOptions: props.dataOptions ? props.dataOptions : {},
      markerInfo: {},
      polylineDefault: "",
      polyline: props.polyline ? props.polyline : [],
      marker: props.marker,
      type: props.type,
      showingInfoWindow: false,
      showDrawerInfo: false,
    };
    this.buttonRef = React.createRef();
  }

  componentDidMount = () => {
    this.setState(
      {
        marker: this.props.marker,
      },
      () => {
        this.buildTags();
      }
    );
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        marker: nextProps.marker,
        showDrawerInfo: nextProps.showDrawerInfo,
      },
      () => {
        this.setState({ polyline: nextProps.polyline }, () => this.buildTags());
      }
    );
    this.setState(
      {
        dataRecieve: nextProps.dataDrawer,
        dataOptions: nextProps.dataOptions,
      },
      () => {
        let sendData = {
          data: nextProps.dataDrawer,
        };
        this.onMarkerClick(sendData, null, null);
      }
    );
  };

  onMarkerClick = (props, marker, e) => {
    switch (this.state.type) {
      case "info":
        this.setState({ showingInfoWindow: false }, () => {
          this.setState({
            showingInfoWindow: true,
            activeMarker: props.data,
            markerInfo: marker,
          });
        });
        break;
      case "drawer":
        this.setState({ showDrawerInfo: false }, () => {
          this.setState({ showDrawerInfo: true, activeMarker: props.data });
        });
        break;
      case "polyline":
        if (props.data) {
          if (props.data.POLLatitude && props.data.PODLatitude) {
            let polyline = [
              {
                lat: parseFloat(props.data.POLLatitude),
                lng: parseFloat(props.data.POLLongitude),
              },
              {
                lat: parseFloat(props.data.PODLatitude),
                lng: parseFloat(props.data.PODLongitude),
              },
            ];
            this.setState({ polyline: polyline });
          }
        }
        break;
      case "polylineDrawer":
        if (props.data) {
          if (props.data.POLLatitude && props.data.PODLatitude) {
            let polyline = [
              {
                lat: parseFloat(props.data.POLLatitude),
                lng: parseFloat(props.data.POLLongitude),
              },
              {
                lat: parseFloat(props.data.PODLatitude),
                lng: parseFloat(props.data.PODLongitude),
              },
            ];
            this.setState({ polyline: polyline });
          }
          this.setState({ showDrawerInfo: false }, () => {
            this.setState({ showDrawerInfo: true, activeMarker: props.data });
          });
        }
        break;
      default:
    }
  };

  onInfoWindowClose = () => {
    this.setState({
      showingInfoWindow: false,
    });
  };

  buildTags = () => {
    let { marker, type } = this.state;
    let tags = [];
    let polylineDefault = [];

    let sizeIconW = 0;
    let sizeIconH = 0;

    marker.map((e) => {
      if (
        e.icon.url ===
        "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapaTCC.png"
      ) {
        sizeIconW = 13;
        sizeIconH = 25;
      } else {
        sizeIconW = 25;
        sizeIconH = 25;
      }

      tags.push(
        <Marker
          key={e.key}
          onClick={this.onMarkerClick}
          title={e.title}
          name={e.name}
          info={e}
          data={e.data}
          position={e.position}
          icon={{
            url: e.icon.url,
            scaledSize: new window.google.maps.Size(sizeIconW, sizeIconH),
          }}
        />
      );
      return e;
    });
    var lineSymbol = {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      scale: 3,
    };
    if (type === "polyline") {
      polylineDefault.push(
        <Polyline
          key={Math.random()}
          path={this.props.data ? this.props.data : []}
          icons={[
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "20px",
            },
          ]}
          strokeOpacity={0}
        />
      );
    }
    if (type === "polylineDrawer") {
      polylineDefault.push(
        <Polyline
          key={Math.random()}
          path={this.props.data ? this.props.data : []}
          icons={[
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "20px",
            },
          ]}
          strokeOpacity={0}
        />
      );
    }
    this.setState({ tags, polylineDefault });
  };

  redirectTo = (event) => {
    this.props.history.push(this.state.dataOptions.config.link);
  };

  handleClick = (a, b, c) => {};

  renderTransportModeIcon = (shipment) => {
    const status_ = {
      Air: <span className="icon-air-shipment icons-front-module"></span>,
      Sea: <span className="icon-sea-shipment icons-front-module"></span>,
      Road: <span className="icon-ground-shipment icons-front-module"></span>,
      Rail: <span className="icon-shipment-rail icons-front-module"></span>,
    };
    if (shipment.TCC === "1") {
      let icon = "icon-charter-shipment2 icons-front-module";
      if (shipment.ShipmentTypeId === 25 || shipment.ShipmentTypeId === 58) {
        icon = "icon-priority-tcc icons-front-module";
      } else if (shipment.ShipmentTypeId === 2) {
        icon = "icon-air-charter-shipment icons-front-module";
      } else if (
        shipment.ShipmentTypeId === 59 ||
        shipment.ShipmentTypeId === 23
      ) {
        icon = "icon-obc-shipment orange icons-front-module";
      }
      return (
        <em
          style={{ color: "#FE5229", fontSize: "50px" }}
          className={icon + " fa-2x mr-4"}
        ></em>
      );
    } else if (shipment.TransportMode === "Air") {
      return status_.Air;
    } else if (shipment.TransportMode === "Sea") {
      return status_.Sea;
    } else if (shipment.TransportMode === "Rail") {
      return status_.Rail;
    }
    return status_.Road;
  };

  markerPin = (e) => {
    if (e.TCC === "1") {
      return "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapaTCC.png";
    }
    return "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapa.png";
  };

  render() {
    let {
      activeMarker,
      markerInfo,
      showDrawerInfo,
      showingInfoWindow,
      polyline,
      polylineDefault,
    } = this.state;
    let dataDrawer = activeMarker;
    if (!this.props.google) {
      return <div>Loading...</div>;
    }
    const info = [
      {
        data: "",
        img: true,
        title: "Aduana",
        value: activeMarker.Aduana,
      },
      {
        data: (
          <em
            className="fa-2x mr-2 fas fa-arrow-alt-circle-right"
            style={{ color: "#001489" }}
          ></em>
        ),
        img: false,
        title: "Total Importaciones",
        value: activeMarker.TotalImpo,
      },
      {
        data: (
          <em
            className="fa-2x mr-2 fas fa-arrow-alt-circle-right"
            style={{ color: "#A7A8A9" }}
          ></em>
        ),
        img: false,
        title: "Total DTA´s",
        value: activeMarker.TotalDTA,
      },
      {
        data: (
          <em
            className="fa-2x mr-2 fas fa-arrow-alt-circle-left"
            style={{ color: "#582C83" }}
          ></em>
        ),
        img: false,
        title: "Total Exportaciones",
        value: activeMarker.TotalExpo,
      },
    ];

    var dataOptions = this.state.dataOptions ? this.state.dataOptions.data : "";

    // console.log('actvie',dataOptions);

    if (dataOptions && markerInfo) {
      dataOptions.map((e) => {
        if (markerInfo.info) {
          e.value = markerInfo.info[e.key];
        }
        return e;
      });
    }
    let dataInfo = this.state.dataOptions
      ? this.state.dataOptions.data
        ? this.state.dataOptions.data
        : info
      : info;
    // let haveButton = this.state.dataOptions ? (this.state.dataOptions.config ? this.state.dataOptions.config.button : false ) : false;

    return (
      <>
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation="overlay"
            icon="labeled"
            vertical
            visible={showDrawerInfo}
            width="wide"
            direction={"right"}
            height="80"
            style={{ width: "426px", maxHeight: "80%" }}
            className="custom-sidebar"
          >
            <Menu.Item
              style={{ fontWeight: "bold" }}
              as="a"
              onClick={() => {
                this.setState({ showDrawerInfo: false, polyline: {} });
              }}
            >
              <span className="close-info-map">{this.props.t("close")}</span>
            </Menu.Item>
            <Card>
              <CardBody>
                <div className="row">
                  <div className="col-6">
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-hover mb-mails">
                          <tbody>
                            <tr>
                              <td>
                                <div className="d-flex">
                                  <div className="mb-mail-meta">
                                    <div style={{ textAlign: "initial" }}>
                                      {this.renderTransportModeIcon(dataDrawer)}
                                    </div>
                                    <div style={{ textAlign: "initial" }}>
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {dataDrawer.Status
                                          ? dataDrawer.Status
                                          : ""}
                                      </span>
                                    </div>
                                    <Link
                                      to={
                                        "/shipments-details/" +
                                        dataDrawer.ShipmentId
                                      }
                                    >
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "12px",
                                          color: "#0561FC",
                                        }}
                                      >
                                        {dataDrawer.ShipmentNumber}
                                      </span>
                                    </Link>
                                    <br />
                                  </div>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div
                                  style={{ textAlign: "initial" }}
                                  className="d-flex"
                                >
                                  <div className="mb-mail-meta">
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {`ETD: ${dataDrawer.ETD}`}
                                    </span>
                                    <br />
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {`ATD: ${dataDrawer.ATD}`}
                                    </span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div
                                  style={{ textAlign: "initial" }}
                                  className="d-flex"
                                >
                                  <div className="mb-mail-meta">
                                    <div>
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {`ETA: ${dataDrawer.ETA}`}
                                      </span>
                                    </div>
                                    <div>
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {`ATA: ${dataDrawer.ATA}`}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-hover mb-mails">
                          <tbody>
                            <tr>
                              <td>
                                <div className="col-12">
                                  <div className="mb-mail-subject">
                                    <Progress
                                      color={"success"}
                                      value={dataDrawer.Progress}
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>

                            <div className="row">
                              <div className="col-1">
                                <div style={{ textAlign: "left" }}>
                                  <div>
                                    <img
                                      alt=""
                                      src={this.markerPin(dataDrawer)}
                                      width={
                                        dataDrawer.TCC === "1" ? "12px" : "25px"
                                      }
                                      style={{
                                        marginLeft:
                                          dataDrawer.TCC === "1"
                                            ? "8px"
                                            : "0px",
                                      }}
                                    ></img>
                                  </div>
                                </div>
                              </div>

                              <div className="col-10">
                                <div style={{ textAlign: "left" }}>
                                  <div className="">
                                    <div className="">
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.props.t("origin")}
                                      </span>
                                    </div>
                                    <span
                                      style={{
                                        fontWeight: "",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {dataDrawer.POLName
                                        ? dataDrawer.POLName
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-1">
                                <div style={{ textAlign: "left" }}>
                                  <div>
                                    <img
                                      alt=""
                                      src={this.markerPin(dataDrawer)}       
                                      width={
                                        dataDrawer.TCC === "1" ? "12px" : "25px"
                                      }
                                      style={{
                                        marginLeft:
                                          dataDrawer.TCC === "1"
                                            ? "8px"
                                            : "0px",
                                      }}
                                    ></img>
                                  </div>
                                </div>
                              </div>

                              <div className="col-10">
                                <div style={{ textAlign: "left" }}>
                                  <div className="">
                                    <div className="">
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {this.props.t("destiny")}
                                      </span>
                                    </div>
                                    <span
                                      style={{
                                        fontWeight: "",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {dataDrawer.PODName
                                        ? dataDrawer.PODName
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
              <div
                className="col-12"
                style={{
                  bottom: "15px",
                  textAlign: "center",
                  position: "fixed",
                }}
              >
                <Button
                  color="primary"
                  className="custom-width-btn"
                  onClick={() => {
                    this.setState({ showDrawerInfo: false });
                    this.props.history.push(
                      "/shipments-details/" + activeMarker.ShipmentId
                    );
                  }}
                >
                  {this.props.t("view_details")}
                </Button>
              </div>
            </Card>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment style={{ paddingLeft: "0", paddingRight: "0" }}>
              <div
                style={{
                  position: "relative",
                  height: this.props.maxHeight ? this.props.maxHeight : "500px",
                }}
              >
                <Map
                  onClick={this.handleClick}
                  styles={[
                    {
                      elementType: "geometry",
                      stylers: [{ color: "#fdfbfb" }],
                    },
                    {
                      elementType: "labels.text.stroke",
                      stylers: [{ color: "red" }],
                    },
                    {
                      elementType: "labels.text.fill",
                      stylers: [{ color: "red" }],
                    },
                    {
                      featureType: "water",
                      elementType: "geometry",
                      stylers: [{ color: "#42AFEE" }],
                    },
                    {
                      featureType: "water",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#515c6d" }],
                    },
                    {
                      featureType: "water",
                      elementType: "labels.text.stroke",
                      stylers: [{ color: "#42AFEE" }],
                    },
                  ]}
                  disableDefaultUI={true}
                  google={this.props.google}
                  zoom={this.props.zoom ? this.props.zoom : 2}
                  initialCenter={
                    this.props.position
                      ? this.props.position
                      : {
                          lat: 24.3005846,
                          lng: -30.447409,
                        }
                  }
                >
                  {this.state.tags}
                  <InfoWindowEx
                    visible={showingInfoWindow}
                    onClose={this.onInfoWindowClose}
                    marker={markerInfo}
                  >
                    <div style={{ minWidth: 250 }}>
                      {dataInfo.map((f, index) => {
                        return (
                          <div
                            key={index}
                            className="row"
                            style={{ marginTop: index === 0 ? 0 : 10 }}
                          >
                            <div className="col-1">
                              {f.img ? (
                                <img
                                  alt="img"
                                  src="https://fsposeidon.blob.core.windows.net/roldan/ICONOGRAFIA_ROL4LL_TRANSPORT_RGB-19.png"
                                  width="25"
                                  height="25"
                                  className="mr-2"
                                ></img>
                              ) : (
                                f.data
                              )}
                            </div>
                            <div
                              className="col-6"
                              style={{
                                marginLeft: 5,
                                fontWeight: "bold",
                                marginTop:
                                  index === 0 || index === dataInfo.length - 1
                                    ? 2
                                    : 0,
                              }}
                            >
                              {f.title}
                            </div>
                            <div
                              className="col-4"
                              style={{ textAlign: "center" }}
                            >
                              {f.value}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </InfoWindowEx>
                  {polylineDefault}
                  <Polyline
                    path={polyline}
                    strokeColor="#0000FF"
                    strokeOpacity={0.8}
                    strokeWeight={2}
                  />
                </Map>
              </div>
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyAl_10ZKSqnrviAV-KSQ6c8i4Sa_gEhEmA",
  v: "3.30",
})(withNamespaces()(withRouter(MapContainer)));
